//Third party lib
import Label from "../../component/Label";
import { useTranslation } from "react-i18next";
//Internal lib
import TypographyLabel from "../../component/Typography";
//Icon
import SchoolIcon from "@mui/icons-material/School";

export default function FeesNotePaid(props: any) {
  const { allActiveStudent } = props;
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <div>
      <div className="flex justify-content-between">
        <div className="active-student-ho">
          <div className=" active-box">
            <div className="active-title">
              {allActiveStudent["Active Student Count"] || 0}
            </div>
            <Label title={t("student")} />
            <div className="active-small-title">
              <TypographyLabel title={t("active")} />
            </div>
          </div>
        </div>
        <div className="feesBox  flex justify-content-between ">
          <div className=" active-box ">
            <div className="active-title">
              {allActiveStudent["Unpaid Student Count"] || 0}
            </div>
            <Label title={t("student")} />
            <div className="active-small-title">
              <TypographyLabel title={t("feesNotPaid")} />
            </div>
          </div>
          <div>
            <div className=" fees-icon">
              <SchoolIcon />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
